<template>
  <div>
    <div class="i-toolbar clearfix">
      <div class="i-toolbar-title">
        <h1>{{LANG.tagRealms}}</h1>
      </div>
      <div class="i-toolbar-btn-container i-btn-container-left"></div>
      <div class="i-toolbar-btn-container i-btn-container-right"></div>
    </div>

    <div id="i-panelview-container">
      <div class="i-panel-item ui-layout-center">
        <TagRealms />
        <!-- <div class="footer placeholder-footer"></div> -->
      </div>
      <div class="i-panel-item ui-layout-east">
        <TagList />
        <!-- <div class="footer placeholder-footer"></div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

// Components
import TagRealms from '@/components/tags/TagRealms.vue';
import TagList from '@/components/tags/TagList.vue';

export default defineComponent({
  name: 'Tags',
  components: {
    TagRealms,
    TagList,
  },
  mounted() {
    this.$store.dispatch('ui/initImperiaLayout');
  },
  computed: {
    ...mapState(['LANG']),
  },
});
</script>

<style scoped lang='scss'>
#i-panelview-container {
  z-index: 1;
}
.i-panel-item {
  height: 100%;

  > :first-child {
    height: inherit;
    overflow: auto;
  }
}

::v-deep table.filelist {
  width: 100%;

  tr:hover {
    background-color: $i-list-hover-bg;
    color: $blue;
    cursor: pointer;
  }
}
</style>
